(function () {
  const INTERVAL_MS = 2600;

  function getOffersFromDrawer() {
    const drawer = document.querySelector('#NebOffersDrawer');
    if (!drawer) return [];

    // Each offer has title + optional code (your section uses .neb-offer-title and code[data-neb-offer-code])
    const offerEls = Array.from(drawer.querySelectorAll('.neb-offer'));
    const offers = [];

    offerEls.forEach((el) => {
      const titleEl = el.querySelector('.neb-offer-title');
      const codeEl = el.querySelector('[data-neb-offer-code]');

      const title = titleEl ? titleEl.textContent.trim() : '';
      const code = codeEl ? codeEl.textContent.trim() : '';

      if (!title && !code) return;

      const text = code
        ? `${title} • Use ${code}`
        : `${title}`;

      offers.push({ title, code, text });
    });

    return offers;
  }

  function startCycling(triggerEl) {
    const textEl = triggerEl.querySelector('[data-neb-offers-trigger-text]');
    if (!textEl) return;

    let offers = getOffersFromDrawer();
    if (!offers.length) {
      textEl.textContent = 'Available offers';
      return;
    }

    let idx = 0;
    let timer = null;

    const render = () => {
      offers = getOffersFromDrawer();
      if (!offers.length) {
        textEl.textContent = 'Available offers';
        return;
      }
      if (idx >= offers.length) idx = 0;
      textEl.textContent = offers[idx].text;
      idx += 1;
    };

    const play = () => {
      if (timer) return;
      render();
      timer = window.setInterval(render, INTERVAL_MS);
    };

    const pause = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    // Start
    play();

    // Pause on hover/focus for readability
    triggerEl.addEventListener('mouseenter', pause);
    triggerEl.addEventListener('mouseleave', play);
    triggerEl.addEventListener('focusin', pause);
    triggerEl.addEventListener('focusout', play);

    // If drawer content changes dynamically, update list
    const drawer = document.querySelector('#NebOffersDrawer');
    if (drawer) {
      const obs = new MutationObserver(() => {
        offers = getOffersFromDrawer();
        idx = 0;
        if (!offers.length) textEl.textContent = 'Available offers';
      });
      obs.observe(drawer, { childList: true, subtree: true });
    }
  }

  function init() {
    const triggers = Array.from(document.querySelectorAll('[data-neb-offers-trigger]'));
    if (!triggers.length) return;

    triggers.forEach(startCycling);
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', init);

  // Also re-init for Shopify section rendering
  document.addEventListener('shopify:section:load', init);
})();